import { CountryWithDetailsType } from "@/shared/types/other.types"

export const useFindCountries = () => {
  const findCountries = (searchString: string, countries: CountryWithDetailsType[]) => {
    const searchLower = searchString.toLowerCase()
    let result: CountryWithDetailsType[] = []
    if (!searchLower) return countries

    const filterSearchString =
      countries.filter((nationality) =>
        nationality.searchString.toLowerCase().includes(searchLower)
      ) || []

    if (filterSearchString.length) {
      result = filterSearchString
    } else {
      result =
        countries.filter((nationality) =>
          nationality.name.toLowerCase().includes(searchLower)
        ) || []
    }

    if (!result.length) return result

    return result.sort((nationality1, nationality2) => {
      if (nationality1.popularCountry && nationality2.popularCountry) {
        return nationality1.popularCountry - nationality2.popularCountry
      }
      if (nationality1.popularCountry) return -1
      if (nationality2.popularCountry) return 1
      return nationality1.desc.localeCompare(nationality2.desc)
    })
  }

  return {
    findCountries,
  }
}
